module.exports = __webpack_public_path__ + "static/media/img-logo-gnb.8f8eb380.svg";